import AnySkillLogo from "./AnySkillLogo";

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen = ({ message = "Loading..." }: LoadingScreenProps) => {
  return (
    <div className="h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin mx-auto mb-4">
          <AnySkillLogo size={48} />
        </div>
        <p className="text-muted-foreground font-inter">{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
